<template>
  <LangRouterLink
    :to="{ name: 'category', params: { slug: category.slug } }"
    :class="['category__card', color(category.color)]"
    :title="category.title"
  >
    <div class="category__card-top">
      <Image :source="category.image" :priority="priority" />
      <Image :source="category.icon" class="category__card-icon" :priority="priority" />
    </div>
    <div class="category__card-content">
      <h3 class="category__card-title small-title">
        <span>{{ category.title }}</span>
        <Icon id="arrow" />
      </h3>
      <p>{{ category.tagline }}</p>
    </div>
  </LangRouterLink>
</template>

<script>
import { Icon, Image, LangRouterLink } from '@/components/global'
import { color } from '@/helpers/color.js'

export default {
  name: 'CategoryCard',
  props: {
    category: {
      type: Object,
      required: true,
    },
    priority: {
      type: Boolean,
      default: false,
    },
  },
  components: { Icon, Image, LangRouterLink },
  methods: {
    color,
  },
}
</script>
